import { atom, getDefaultStore, useAtomValue } from 'jotai';

import { checkPermissions } from '@/features/notifications/utils/pushNotifications';

export const notificationPermissionAtom = atom<boolean>(false);

export const refreshNotificationPermission = async () => {
  const granted = await checkPermissions();
  getDefaultStore().set(notificationPermissionAtom, granted);
};

export const useGetNotificationPermission = () =>
  useAtomValue(notificationPermissionAtom);
